module.exports = __webpack_public_path__ + "img/list-download-blue.bf028aa3.svg";